import { MpsRole } from '../../models/mps-user.model';

export class User {
  id!: number;
  firstname!: string;
  lastname!: string;
  email!: string;
  lang!: string;
  last_connection!: string;
  igg!: string;
  role_id!: number;
  deleted_at?: string | null;
  purge_scheduled_at?: string | null;

  role!: MpsRole;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
